import FretboardsAPI from "@/api/apiFretboards";

export const namespaced = true;

export const state = {
  catalog: [],
  choices: {}
};

export const getters = {};

export const mutations = {
  SET_CATALOG(state, catalog) {
    state.catalog = catalog;
  },
  SET_CHOICES(state, choices) {
    state.choices = choices;
  }
};

export const actions = {
  async loadCatalog({ commit }, filters) {
    let catalog = await FretboardsAPI.getFretboardList(filters);
    commit("SET_CATALOG", catalog);
    return catalog;
  },

  async loadChoices({ commit }) {
    let choices = await FretboardsAPI.getFretboardChoices();
    commit("SET_CHOICES", choices);
    return choices;
  },

  async saveFretboard(_, data) {
    return await FretboardsAPI.saveFretboard(data);
  }
};
